var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Text } from 'react-native';
import { withZeroText } from '../../utils/withZeroText';
import { Flex } from '../Flex';
import { CountDownV2 } from './CountDown';
export function CountDownBox(props) {
    const { boxStyle, width = 18, height = 18, textBgColor = '#FF4906', splitColor = 'rgba(255, 73, 6, 0.2)', splitTextStyle, splitNode, splitBoxStyle, textColor = '#fff', textStyle: outerTextStyle, renderWhenOverOneDay, renderCustomNode } = props, restProps = __rest(props, ["boxStyle", "width", "height", "textBgColor", "splitColor", "splitTextStyle", "splitNode", "splitBoxStyle", "textColor", "textStyle", "renderWhenOverOneDay", "renderCustomNode"]);
    const boxBs = { w: width, h: height, borderRadius: 3, bg: textBgColor };
    const textStyle = {
        fontSize: 11,
        fontWeight: '700',
        color: textColor,
    };
    const splitNodeContent = splitNode !== null && splitNode !== void 0 ? splitNode : (React.createElement(Flex, { flex: 'flexCenter', style: [{ width: 10 }, splitBoxStyle] },
        React.createElement(Text, { style: [{ fontSize: 11, color: splitColor }, splitTextStyle] }, ":")));
    function renderBox(text) {
        return (React.createElement(Flex, { flex: 'flexCenter', bs: boxBs, style: boxStyle },
            React.createElement(Text, { style: [textStyle, outerTextStyle] }, withZeroText(text))));
    }
    return (React.createElement(CountDownV2, Object.assign({}, restProps), (p) => {
        const dayNode = p.days > 0 ? (React.createElement(React.Fragment, null,
            renderBox(p.days),
            splitNodeContent)) : null;
        function renderDefaultNode() {
            return renderCustomNode ? (renderCustomNode(p)) : (React.createElement(React.Fragment, null,
                dayNode,
                renderBox(p.hours),
                splitNodeContent,
                renderBox(p.minutes),
                splitNodeContent,
                renderBox(p.seconds)));
        }
        return (React.createElement(Flex, null, p.days > 0 && renderWhenOverOneDay
            ? renderWhenOverOneDay(p)
            : renderDefaultNode()));
    }));
}
